import { render, staticRenderFns } from "./SelectModal.vue?vue&type=template&id=531b9d9a&scoped=true&"
import script from "./SelectModal.vue?vue&type=script&lang=ts&"
export * from "./SelectModal.vue?vue&type=script&lang=ts&"
import style0 from "./SelectModal.vue?vue&type=style&index=0&id=531b9d9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531b9d9a",
  null
  
)

export default component.exports